module.exports = __webpack_public_path__ + "img/notFound.ac3ba299.svg";